<template>
  <div class="container containerForm">
    <h2 style="text-align: center">إضافة منتج جديد</h2>
    <form>
      <div class="form-group">
        <label for="name">الاسم</label>
        <input type="text" class="form-control" id="name" v-model="productData.name" />
        <!-- <div v-if="errors.name" class="invalid-feedback">
          {{ errors.name }}
        </div> -->
      </div>
      <div class="form-group">
        <label for="description">الوصف بالإنجليزية</label>
        <textarea class="form-control" style="height: 100px" id="description" v-model="productData.description"
          :class="{ 'is-invalid': errors.description }"></textarea>
        <div v-if="errors.description" class="invalid-feedback">
          {{ errors.description }}
        </div>
      </div>
      <div class="form-group">
        <label for="description_ar">الوصف بالعربية</label>
        <textarea class="form-control" style="height: 100px" id="description_ar" v-model="productData.description_ar"
          :class="{ 'is-invalid': errors.description_ar }"></textarea>
        <div v-if="errors.description_ar" class="invalid-feedback">
          {{ errors.description_ar }}
        </div>
      </div>
      <div class="form-group">
        <label for="height">الطول</label>
        <input type="text" class="form-control" id="height" v-model="productData.height"
          :class="{ 'is-invalid': errors.height }" />
        <div v-if="errors.height" class="invalid-feedback">
          {{ errors.height }}
        </div>
      </div>

      <!-- <div class="form-group">
        <label for="height_ar">الطول بالعربية</label>
        <input type="text" class="form-control" id="height_ar" v-model="productData.height_ar"
          :class="{ 'is-invalid': errors.height_ar }" />
        <div v-if="errors.height_ar" class="invalid-feedback">
          {{ errors.height_ar }}
        </div>
      </div> -->

      <div class="form-group">
        <label for="depth">العرض</label>
        <input type="text" class="form-control" id="depth" v-model="productData.depth"
          :class="{ 'is-invalid': errors.depth }" />
        <div v-if="errors.depth" class="invalid-feedback">
          {{ errors.depth }}
        </div>
      </div>

      <!-- <div class="form-group">
        <label for="depth_ar">العرض بالعربية</label>
        <input type="number" class="form-control" id="depth_ar" v-model="productData.depth_ar"
          :class="{ 'is-invalid': errors.depth_ar }" />
        <div v-if="errors.depth_ar" class="invalid-feedback">
          {{ errors.depth_ar }}
        </div>
      </div> -->

      <div class="form-group">
        <label for="style">الستايل بالإنجليزية</label>
        <input type="text" class="form-control" id="style" v-model="productData.style"
          :class="{ 'is-invalid': errors.style }" />
        <div v-if="errors.style" class="invalid-feedback">
          {{ errors.style }}
        </div>
      </div>
      <div class="form-group">
        <label for="style_ar">الستايل بالعربية</label>
        <input type="text" class="form-control" id="style_ar" v-model="productData.style_ar"
          :class="{ 'is-invalid': errors.style_ar }" />
        <div v-if="errors.style_ar" class="invalid-feedback">
          {{ errors.style_ar }}
        </div>
      </div>

      <div class="form-group">
        <label for="execute">هل تم تنفيذ المنتج من قبل؟</label>
        <select class="form-control" id="execute" v-model="productData.execute_ar">
          <option value="">قم بالاختيار</option>
          <option value="تم التنفيذ بمقاس من قبل">
            تم التنفيذ بمقاس من قبل
          </option>
          <option value="لم يتم التنفيذ بمقاس من قبل">
            لم يتم التنفيذ بمقاس من قبل
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="category">القسم</label>
        <select class="form-control" id="category" v-model="productData.categoryId">
          <option value="">اختر قسمًا</option>
          <option v-for="category in categories" :value="category.id" :key="category.id">
            {{ category.name_ar }}
          </option>
        </select>
      </div>
      <div style="float:none;">
        <div style="float:none;">
          <p style="font-size: 18px; font-weight: bold; color: rgb(88, 88, 88);">الخامة</p>
        </div>
        <div class="form-group col-12">
          <div v-for="(material, index) in materialsData" :key="material['الرقم التسلسلي']" class="checkboxes d-block">
            <input type="checkbox" :id="'checkbox' + material['الرقم التسلسلي']"
              @change="toggleInput(material['الرقم التسلسلي'])">
            <span :for="'checkbox' + material['الرقم التسلسلي']" style="font-size: 14px;" class="px-1 pt-1">{{
          material['الاسم'] }}</span>
            <input type="text" :id="'input' + material['الرقم التسلسلي']" class="hidden form-control"
              :placeholder="'سعر المنتج بخامة ' + material['الاسم']"
              @input="updateMaterialPrice(material['الرقم التسلسلي'], $event.target.value)">
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="image">صورة المنتج</label>
        <input type="file" accept="image/*" class="form-control" id="image" @change="handleImageUpload" />
      </div>

      <button type="submit" class="btn btn-primary" @click.prevent="AddProduct">
        حفظ
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      productData: {
        name: "",
        description: "",
        description_ar: "",
        height: "",
        depth: "",
        style: "",
        style_ar: "",
        categoryId: "",
        image: "",
        execute_ar: "",
        selectedMaterials: [],
      },
      errors: {
        name: "",
        description: "",
        description_ar: "",
        height: "",
        depth: "",
        style: "",
        style_ar: "",
      },
      categories: [],
      materialsData: []
    };
  },
  methods: {
    toggleInput(materialId) {
      const checkbox = document.getElementById('checkbox' + materialId);
      const input = document.getElementById('input' + materialId);
      if (input) {
        if (checkbox.checked) {
          input.classList.remove('hidden');
          // Add material and price to selectedMaterials
          this.productData.selectedMaterials.push({
            materialID: materialId,
            price: 0, // Default price, will be updated on input
          });
        } else {
          input.value = '';
          input.classList.add('hidden');
          this.productData.selectedMaterials = this.productData.selectedMaterials.filter(m => m.materialID !== materialId);
        }
      } else {
        // console.error('Input element not found.');
      }
    },
    updateMaterialPrice(materialId, price) {
      // Find the material and update its price
      const material = this.productData.selectedMaterials.find(m => m.materialID === materialId);
      if (material) {
        material.price = price;
      }
    },
    AddProduct() {
      if (this.productData.execute_ar === "تم التنفيذ بمقاس من قبل") {
        this.productData.execute = "Executed with a measurement";
      } else if (this.productData.execute_ar === "لم يتم التنفيذ بمقاس من قبل") {
        this.productData.execute = "Not executed with a previous measurement";
      }
      // Reset previous errors
      this.errors = {
        description: "",
        description_ar: "",
        height: "",
        depth: "",
        style: "",
        style_ar: "",
      };

      // Custom validation for letters
      // const arabicLettersRegex = /^[\u0621-\u064A\s]+$/; // Arabic letters and spaces
      // const englishLettersRegex = /^[A-Za-z\s]+$/; // English letters and spaces
      const arabicLettersRegex = /^[^A-Za-z]*$/; // Arabic letters and spaces
      const englishLettersRegex =
        /^[A-Za-z0-9!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-|'"\s]*$/; // English letters and spaces

      // Validation for required fields
      if (
        !this.productData.description ||
        !this.productData.description_ar ||
        !this.productData.height ||
        !this.productData.depth ||
        !this.productData.style ||
        !this.productData.style_ar ||
        !this.productData.categoryId ||
        !this.productData.execute_ar ||
        !this.productData.image
      ) {
        if (!this.productData.description) {
          this.errors.description = "الرجاء إدخال الوصف بالإنجليزية";
        } else {
          if (!englishLettersRegex.test(this.productData.description)) {
            this.errors.description = "الرجاء إدخال حروف إنجليزية فقط";
          }
        }
        if (!this.productData.description_ar) {
          this.errors.description_ar = "الرجاء إدخال الوصف بالعربية";
        } else {
          if (!arabicLettersRegex.test(this.productData.description_ar)) {
            this.errors.description_ar = "الرجاء إدخال حروف عربية فقط";
          }
        }
        // if (!this.productData.material_ar) {
        //   this.errors.material_ar = "الرجاء إدخال الخامة بالعربية";
        // } else {
        //   if (!arabicLettersRegex.test(this.productData.material_ar)) {
        //     this.errors.material_ar = "الرجاء إدخال حروف عربية فقط";
        //   }
        // }
        // if (!this.productData.material) {
        //   this.errors.material = "الرجاء إدخال الخامة بالإنجليزية";
        // } else {
        //   if (!englishLettersRegex.test(this.productData.material)) {
        //     this.errors.material = "الرجاء إدخال حروف إنجليزية فقط";
        //   }
        // }

        if (!this.productData.style_ar) {
          this.errors.style_ar = "الرجاء إدخال الستايل بالعربية";
        } else {
          if (!arabicLettersRegex.test(this.productData.style_ar)) {
            this.errors.style_ar = "الرجاء إدخال حروف عربية فقط";
          }
        }
        if (!this.productData.style) {
          this.errors.style = "الرجاء إدخال الستايل بالإنجليزية";
        } else {
          if (!englishLettersRegex.test(this.productData.style)) {
            this.errors.style = "الرجاء إدخال حروف إنجليزية فقط";
          }
        }
        if (
          parseFloat(this.productData.height) <= 0 ||
          isNaN(parseFloat(this.productData.height))
        ) {
          this.errors.height = "يجب أن يكون الطول رقمًا موجبًا";
        }
        if (
          parseFloat(this.productData.depth) <= 0 ||
          isNaN(parseFloat(this.productData.depth))
        ) {
          this.errors.depth = "يجب أن يكون العرض رقمًا موجبًا";
        }
        if (
          parseFloat(this.productData.depth_ar) <= 0 ||
          isNaN(parseFloat(this.productData.depth_ar))
        ) {
          this.errors.depth_ar = "يجب أن يكون العرض رقمًا موجبًا";
        }
        // if (
        //   parseFloat(this.productData.price) <= 0 ||
        //   isNaN(parseFloat(this.productData.price))
        // ) {
        //   this.errors.price = "يجب أن يكون السعر رقمًا موجبًا";
        // }
        if (!this.productData.categoryId) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء اختيار اسم القسم",
            position: "bottomRight",
          });
        }
        if (!this.productData.execute_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء تحديد تم التنفيذ من قبل أم لا",
            position: "bottomRight",
          });
        }
        if (!this.productData.image) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء اختيار صورة المنتج",
            position: "bottomRight",
          });
        }
        return; // Stop form submission if any required field is missing
      }
      // Create a FormData object to send image as a file
      const formData = new FormData();
      for (const key in this.productData) {
        if (this.productData.hasOwnProperty(key)) {
          if (key === 'name' && this.productData[key] === "") {
            continue; // Skip appending the name if it's empty
          }
          // Append all fields except image
          if (key !== "image") {
            formData.append(key, this.productData[key]);
          }
        }
      }

      // Append the image separately
      if (this.productData.image instanceof File) {
        formData.append("image", this.productData.image);
      }

      if (this.productData.selectedMaterials.length > 0) {
        formData.append('materials', JSON.stringify(this.productData.selectedMaterials));
      }

      Axios
        .post("/products", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Important for sending files
          },
        })
        .then((response) => {
          // Reset form fields after successful submission
          this.productData = {
            name: "",
            description: "",
            description_ar: "",
            height: "",
            depth: "",
            style: "",
            style_ar: "",
            categoryId: "",
            execute_ar: "",
            image: "",
          };
          this.$iziToast.success({
            timeout: 2000,
            message: "تم إضافة المنتج بنجاح",
            position: "bottomRight",
          });
          this.$router.push("/admin/products");
        })
        .catch((error) => {
          // console.error(error);
          if (error.response && error.response.data) {
            const errorMessage = error.response.data.message;
            this.$iziToast.error({
              timeout: 5000,
              message: errorMessage,
              position: "bottomRight",
            });
          } else {
            this.$iziToast.error({
              timeout: 2000,
              message: "فشل الإضافة",
              position: "bottomRight",
            });
          }
        });
    },
    fetchCategories() {
      Axios
        .get("/dashboard/category")
        .then((response) => {
          // console.log(response.data.categories);
          // Get all categories from all pages
          const allCategories = response.data.categories;
          const totalPages = response.data.totalPages;

          // Check if there are more pages to fetch
          if (totalPages > 1) {
            const nextPagePromises = [];

            // Start fetching from page 2, as we already fetched page 1
            for (let page = 2; page <= totalPages; page++) {
              nextPagePromises.push(
                Axios.get(
                  `/dashboard/category?page=${page}`
                )
              );
            }

            // Fetch all pages concurrently
            return Promise.all(nextPagePromises)
              .then((nextPagesResponses) => {
                // Extract categories from all pages
                nextPagesResponses.forEach((pageResponse) => {
                  allCategories.push(pageResponse.data.categories[0]);
                });

                // Set the categories data
                this.categories = allCategories;
                // console.log(this.categories);
              })
              .catch((error) => {
                // console.error(error);
              });
          } else {
            // If there is only one page, set the categories data directly
            this.categories = allCategories;
          }
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    handleImageUpload(event) {
      const selectedImage = event.target.files[0];
      if (selectedImage) {
        // Set the selected image to productData.image
        this.productData.image = selectedImage;
      }
    },
    fetchMaterials() {
      Axios.get("/dashboard/materials")
        .then((response) => {
          this.materialsData = response.data.map((material) => {
            const row = {
              الاسم: material.name_ar + " ",
              "الاسم بالإنجليزية": material.name,
              "الرقم التسلسلي": material.id,
              loading: true,
            };
            return row;
          });
          // console.log(this.materialsData);
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchMaterials();
  },
};

</script>

<style>
.containerForm {
  max-width: 800px;
  margin: 0 auto;
  margin-top: 30px;
  padding: 20px;
  background-color: #ffffffb9;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-heading {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.custom-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-size: 18px;
  font-weight: bold;
  color: rgb(88, 88, 88)
}

.form-control {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

textarea.form-control {
  resize: vertical;
}

.custom-btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
}

.custom-btn:hover {
  background-color: #0056b3;
}

.hidden {
  display: none;
}
</style>
